var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionStore } from "./actionStore";
export var initial = {};
export var reducerStore = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionStore.SelectPackage:
            return __assign({}, state, { package: action.packageInfo });
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/store/reducerStore.ts
// module id = 2978
// module chunks = 3